
    <!-- Teal gradient üst bar - Flutter base_page.dart'tan -->
    <header class="hmi-header">
      <div class="hmi-header-bg"></div>
      <div class="hmi-header-content">
        <!-- Sol: Logo -->
        <div class="hmi-header-sol">
          <div class="hmi-logo-wrap">
            <img src="./simgeler/logo.webp" alt="FikoYT" class="hmi-logo" />
          </div>
          <img src="./simgeler/fikoyt_yazi.webp" alt="FikoYT" class="hmi-marka-img" />
        </div>

        <!-- Orta: Başlık bandı -->
        <div class="hmi-baslik-bant">
          <span class="hmi-baslik-info">ⓘ</span>
          <span class="hmi-baslik-text">UYAR Döküm HMI Bilgi Ekranı</span>
          <span class="hmi-baslik-info">ⓘ</span>
        </div>

        <!-- Sağ: Bağlantı + Saat -->
        <div class="hmi-header-sag">
          <div class="hmi-durum-grubu">
            <div class="hmi-sinyal-wrap" [class.aktif]="wsConnected">
              <div class="hmi-ripple-dot" [class.animating]="wsConnected"></div>
              <span class="hmi-sinyal-ikon">📡</span>
            </div>
            <div class="hmi-sinyal-wrap" [class.aktif]="wsConnected">
              <div class="hmi-ripple-dot" [class.animating]="wsConnected"></div>
              <span class="hmi-sinyal-ikon">⚡</span>
            </div>
          </div>
          <div class="hmi-saat-grubu">
            <span class="hmi-tarih">{{ tarih }}</span>
            <span class="hmi-saat">{{ saat }}</span>
          </div>
          <div class="hmi-pil-wrap">
            <div class="hmi-ripple-dot animating pil"></div>
            @if (bataryaDestekleniyor && !bataryaSarj) {
              <span class="hmi-pil-ikon">🔋</span>
              <span class="hmi-pil-yuzde">{{ bataryaSeviye }}%</span>
            } @else {
              <span class="hmi-pil-ikon">🔌</span>
            }
          </div>
          <div class="hmi-header-aksiyonlar">
            <button class="hmi-aksiyon-btn" (click)="toggleKaranlikMod()" [title]="karanlikMod ? 'Aydınlık Mod' : 'Karanlık Mod'">
              {{ karanlikMod ? '☀️' : '🌙' }}
            </button>
            <button class="hmi-aksiyon-btn" (click)="toggleTamEkran()" [title]="tamEkran ? 'Pencere Modu' : 'Tam Ekran'">
              {{ tamEkran ? '🔲' : '⛶' }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Uzak komut ekran mesaji overlay -->
    @if (ekranMesajiGoster) {
      <div class="hmi-ekran-mesaj-overlay" [style.background]="ekranMesajiRenk">
        <div class="hmi-ekran-mesaj-icerik">
          <span class="hmi-ekran-mesaj-ikon">📢</span>
          <span class="hmi-ekran-mesaj-text">{{ ekranMesaji }}</span>
        </div>
        <button class="hmi-ekran-mesaj-kapat" (click)="ekranMesajiGoster = false">✕</button>
      </div>
    }

    <!-- Askıda overlay -->
    @if (cihazAskida) {
      <div class="hmi-askida-overlay">
        <div class="hmi-askida-icerik">
          <div class="hmi-askida-ikon">⏸️</div>
          <h2 class="hmi-askida-baslik">Cihaz Askıya Alındı</h2>
          <p class="hmi-askida-aciklama">
            Bu cihaz yönetici tarafından geçici olarak askıya alınmıştır.
            Lütfen yöneticinizle iletişime geçin.
          </p>
          <div class="hmi-askida-bilgi">
            <span>Cihaz aktif hale getirildiğinde ekran otomatik olarak açılacaktır.</span>
          </div>
        </div>
      </div>
    }

    <!-- İçerik -->
    <main class="hmi-main">
      <router-outlet></router-outlet>
    </main>
